export const FETCH_DSR_LOGS = '@@team/dsr-logs';
export const FETCH_DSR_LOGS_SUCCESS = '@@team/dsr-logs-success';
export const FETCH_DSR_LOGS_FAILURE = '@@team/dsr-logs-failure';

// New action types for DSR log creation and submission
export const CREATE_DSR_LOG = '@@team/create-dsr-log';
export const CREATE_DSR_LOG_SUCCESS = '@@team/create-dsr-log-success';
export const CREATE_DSR_LOG_FAILURE = '@@team/create-dsr-log-failure';

export const SUBMIT_DSR_LOG = '@@team/submit-dsr-log';
export const SUBMIT_DSR_LOG_SUCCESS = '@@team/submit-dsr-log-success';
export const SUBMIT_DSR_LOG_FAILURE = '@@team/submit-dsr-log-failure';

export const UN_SUBMIT_DSR_LOG = '@@team/un-submit-dsr-log';
export const UN_SUBMIT_DSR_LOG_SUCCESS = '@@team/un-submit-dsr-log-success';
export const UN_SUBMIT_DSR_LOG_FAILURE = '@@team/un-submit-dsr-log-failure';

export const GENERATE_FLASH_REPORT = '@@team/generate-flash-report';
export const GENERATE_FLASH_REPORT_SUCCESS = '@@team/generate-flash-report-success';
export const GENERATE_FLASH_REPORT_FAILURE = '@@team/generate-flash-report-failure';

// New action types for updating DSR log sections
export const UPDATE_DSR_LOG_SECTIONS = '@@team/update-dsr-log-sections';
export const UPDATE_DSR_LOG_SECTIONS_SUCCESS = '@@team/update-dsr-log-sections-success';
export const UPDATE_DSR_LOG_SECTIONS_FAILURE = '@@team/update-dsr-log-sections-failure';

// New action types for technician log operations
export const FETCH_TECHNICIAN_LOG = '@@team/fetch-technician-log';
export const FETCH_TECHNICIAN_LOG_SUCCESS = '@@team/fetch-technician-log-success';
export const FETCH_TECHNICIAN_LOG_FAILURE = '@@team/fetch-technician-log-failure';

export const UPDATE_TECHNICIAN_LOG = '@@team/update-technician-log';
export const UPDATE_TECHNICIAN_LOG_SUCCESS = '@@team/update-technician-log-success';
export const UPDATE_TECHNICIAN_LOG_FAILURE = '@@team/update-technician-log-failure';

// New action types for material log operations
export const FETCH_MATERIAL_LOG = '@@team/fetch-material-log';
export const FETCH_MATERIAL_LOG_SUCCESS = '@@team/fetch-material-log-success';
export const FETCH_MATERIAL_LOG_FAILURE = '@@team/fetch-material-log-failure';

export const UPDATE_MATERIAL_LOG = '@@team/update-material-log';
export const UPDATE_MATERIAL_LOG_SUCCESS = '@@team/update-material-log-success';
export const UPDATE_MATERIAL_LOG_FAILURE = '@@team/update-material-log-failure';

// New action types for consumables log operations
export const FETCH_CONSUMABLES_LOG = '@@team/fetch-consumables-log';
export const FETCH_CONSUMABLES_LOG_SUCCESS = '@@team/fetch-consumables-log-success';
export const FETCH_CONSUMABLES_LOG_FAILURE = '@@team/fetch-consumables-log-failure';

export const UPDATE_CONSUMABLES_LOG = '@@team/update-consumables-log';
export const UPDATE_CONSUMABLES_LOG_SUCCESS = '@@team/update-consumables-log-success';
export const UPDATE_CONSUMABLES_LOG_FAILURE = '@@team/update-consumables-log-failure';

// New action types for equipment usage log operations
export const FETCH_EQUIPMENT_USAGE_LOG = '@@team/fetch-equipment-usage-log';
export const FETCH_EQUIPMENT_USAGE_LOG_SUCCESS = '@@team/fetch-equipment-usage-log-success';
export const FETCH_EQUIPMENT_USAGE_LOG_FAILURE = '@@team/fetch-equipment-usage-log-failure';

export const UPDATE_EQUIPMENT_USAGE_LOG = '@@team/update-equipment-usage-log';
export const UPDATE_EQUIPMENT_USAGE_LOG_SUCCESS = '@@team/update-equipment-usage-log-success';
export const UPDATE_EQUIPMENT_USAGE_LOG_FAILURE = '@@team/update-equipment-usage-log-failure';

// New action types for EHS log operations
export const FETCH_EHS_LOG = '@@team/fetch-ehs-log';
export const FETCH_EHS_LOG_SUCCESS = '@@team/fetch-ehs-log-success';
export const FETCH_EHS_LOG_FAILURE = '@@team/fetch-ehs-log-failure';

export const UPDATE_EHS_LOG = '@@team/update-ehs-log';
export const UPDATE_EHS_LOG_SUCCESS = '@@team/update-ehs-log-success';
export const UPDATE_EHS_LOG_FAILURE = '@@team/update-ehs-log-failure';

export const ADD_EHS_LOG_ITEM = '@@team/add-ehs-log-item';
export const ADD_EHS_LOG_ITEM_SUCCESS = '@@team/add-ehs-log-item-success';
export const ADD_EHS_LOG_ITEM_FAILURE = '@@team/add-ehs-log-item-failure';

export const DELETE_EHS_LOG_ITEM = '@@team/delete-ehs-log-item';
export const DELETE_EHS_LOG_ITEM_SUCCESS = '@@team/delete-ehs-log-item-success';
export const DELETE_EHS_LOG_ITEM_FAILURE = '@@team/delete-ehs-log-item-failure';

export const FETCH_ALL_EHS_ISSUES = '@@team/fetch-all-ehs-issues';
export const FETCH_ALL_EHS_ISSUES_SUCCESS = '@@team/fetch-all-ehs-issues-success';
export const FETCH_ALL_EHS_ISSUES_FAILURE = '@@team/fetch-all-ehs-issues-failure';

// New action types for Downtime log operations
export const FETCH_DOWNTIME_LOG = '@@team/fetch-downtime-log';
export const FETCH_DOWNTIME_LOG_SUCCESS = '@@team/fetch-downtime-log-success';
export const FETCH_DOWNTIME_LOG_FAILURE = '@@team/fetch-downtime-log-failure';

export const UPDATE_DOWNTIME_LOG = '@@team/update-downtime-log';
export const UPDATE_DOWNTIME_LOG_SUCCESS = '@@team/update-downtime-log-success';
export const UPDATE_DOWNTIME_LOG_FAILURE = '@@team/update-downtime-log-failure';

export const ADD_DOWNTIME_LOG_ITEM = '@@team/add-downtime-log-item';
export const ADD_DOWNTIME_LOG_ITEM_SUCCESS = '@@team/add-downtime-log-item-success';
export const ADD_DOWNTIME_LOG_ITEM_FAILURE = '@@team/add-downtime-log-item-failure';

export const DELETE_DOWNTIME_LOG_ITEM = '@@team/delete-downtime-log-item';
export const DELETE_DOWNTIME_LOG_ITEM_SUCCESS = '@@team/delete-downtime-log-item-success';
export const DELETE_DOWNTIME_LOG_ITEM_FAILURE = '@@team/delete-downtime-log-item-failure';

export const FETCH_DOWNTIME_EQUIPMENTS = '@@team/fetch-downtime-equipments';
export const FETCH_DOWNTIME_EQUIPMENTS_SUCCESS = '@@team/fetch-downtime-equipments-success';
export const FETCH_DOWNTIME_EQUIPMENTS_FAILURE = '@@team/fetch-downtime-equipments-failure';

// New action types for Production log operations
export const FETCH_PRODUCTION_LOG = '@@team/fetch-production-log';
export const FETCH_PRODUCTION_LOG_SUCCESS = '@@team/fetch-production-log-success';
export const FETCH_PRODUCTION_LOG_FAILURE = '@@team/fetch-production-log-failure';

export const UPDATE_PRODUCTION_LOG = '@@team/update-production-log';
export const UPDATE_PRODUCTION_LOG_SUCCESS = '@@team/update-production-log-success';
export const UPDATE_PRODUCTION_LOG_FAILURE = '@@team/update-production-log-failure';

export const UPSERT_PRODUCTION_ITEM = '@@team/upsert-production-item';
export const UPSERT_PRODUCTION_ITEM_SUCCESS = '@@team/upsert-production-item-success';
export const UPSERT_PRODUCTION_ITEM_FAILURE = '@@team/upsert-production-item-failure';

export const DELETE_PIPE_GROUP = '@@team/delete-pipe-group';
export const DELETE_PIPE_GROUP_SUCCESS = '@@team/delete-pipe-group-success';
export const DELETE_PIPE_GROUP_FAILURE = '@@team/delete-pipe-group-failure';

export const DELETE_PRODUCTION_JOINT = '@@team/delete-production-joint';
export const DELETE_PRODUCTION_JOINT_SUCCESS = '@@team/delete-production-joint-success';
export const DELETE_PRODUCTION_JOINT_FAILURE = '@@team/delete-production-joint-failure';

// New action types for pipe group operations
export const UPDATE_PIPE_GROUP = '@@team/update-pipe-group';
export const UPDATE_PIPE_GROUP_SUCCESS = '@@team/update-pipe-group-success';
export const UPDATE_PIPE_GROUP_FAILURE = '@@team/update-pipe-group-failure';

export const UPDATE_GROUP_ITEM = '@@team/update-group-item';
export const UPDATE_GROUP_ITEM_SUCCESS = '@@team/update-group-item-success';
export const UPDATE_GROUP_ITEM_FAILURE = '@@team/update-group-item-failure';

// New action type for updating pipe data (sub-string)
export const UPDATE_PIPE_DATA = '@@team/update-pipe-data';
export const UPDATE_PIPE_DATA_SUCCESS = '@@team/update-pipe-data-success';
export const UPDATE_PIPE_DATA_FAILURE = '@@team/update-pipe-data-failure';

// Clear section data action types
export const CLEAR_TECHNICIAN_LOG = '@@team/clear-technician-log';
export const CLEAR_MATERIAL_LOG = '@@team/clear-material-log';
export const CLEAR_CONSUMABLES_LOG = '@@team/clear-consumables-log';
export const CLEAR_EQUIPMENT_USAGE_LOG = '@@team/clear-equipment-usage-log';
export const CLEAR_EHS_LOG = '@@team/clear-ehs-log';
export const CLEAR_DOWNTIME_LOG = '@@team/clear-downtime-log';
export const CLEAR_PRODUCTION_LOG = '@@team/clear-production-log';
